import { EnergyBackupSystemDesign } from 'types';

export const calculateEnergyBackupSystemDesignTotalCost = (systemDesign: EnergyBackupSystemDesign): number => {
  const totalCost = systemDesign?.equipment?.reduce((sum, equipment) => {
    return sum + (equipment.totalCost || 0);
  }, 0);
  return totalCost;
};
